// extracted by mini-css-extract-plugin
export default {"companySelectForm":"CompanySelectForm_companySelectForm__zLkSJ","form":"CompanySelectForm_form__+sYOT"};